import { render, staticRenderFns } from "./MedicoCard.vue?vue&type=template&id=52cfa921&"
import script from "./MedicoCard.vue?vue&type=script&lang=js&"
export * from "./MedicoCard.vue?vue&type=script&lang=js&"
import style0 from "./MedicoCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VSheet})
